// 引入完整的core-js polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// IE中的DOM事件构造函数polyfill
;(function () {
  if (
    typeof window === 'undefined' ||
    (window.Event && typeof window.Event === 'function')
  ) {
    return
  }

  function Event(event: string, params?: EventInit) {
    params = params || {}
    const evt = document.createEvent('Event')
    evt.initEvent(event, !!params.bubbles, !!params.cancelable)
    return evt
  }

  ;(window as any).Event = Event
})()

// IE 对 requestAnimationFrame 的支持
;(function () {
  if (typeof window === 'undefined') return

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback) {
      return window.setTimeout(function () {
        callback(Date.now())
      }, 16.7)
    }
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id)
    }
  }
})()

// Element.matches polyfill (IE9+)
if (typeof window !== 'undefined' && !Element.prototype.matches) {
  Element.prototype.matches =
    (Element.prototype as any).msMatchesSelector ||
    (Element.prototype as any).webkitMatchesSelector
}

// Element.closest polyfill
if (typeof window !== 'undefined' && !Element.prototype.closest) {
  Element.prototype.closest = function (s: string) {
    let el = this
    do {
      if (el.matches(s)) return el
      el = el.parentElement || (el.parentNode as Element)
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

// 数组方法 polyfills
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (
      predicate: (value: any, index: number, obj: any[]) => boolean,
      thisArg?: any
    ): any {
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }
      var o = Object(this)
      var len = o.length >>> 0
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function')
      }
      var thisArg = arguments[1]
      var k = 0
      while (k < len) {
        var kValue = o[k]
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue
        }
        k++
      }
      return undefined
    },
    configurable: true,
    writable: true,
  })
}

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (searchElement: any, fromIndex?: number): boolean {
      if (this == null) {
        throw new TypeError('"this" is null or not defined')
      }
      var o = Object(this)
      var len = o.length >>> 0
      if (len === 0) {
        return false
      }
      var n = fromIndex !== undefined ? fromIndex | 0 : 0
      var k = Math.max(n >= 0 ? n : len + n, 0)
      function sameValueZero(x: any, y: any): boolean {
        return (
          x === y ||
          (typeof x === 'number' &&
            typeof y === 'number' &&
            isNaN(x) &&
            isNaN(y))
        )
      }
      while (k < len) {
        if (sameValueZero(o[k], searchElement)) {
          return true
        }
        k++
      }
      return false
    },
    configurable: true,
    writable: true,
  })
}

// 对象方法 polyfills
if (!Object.entries) {
  Object.entries = function (obj: any): [string, any][] {
    var ownProps = Object.keys(obj)
    var i = ownProps.length
    var resArray = new Array(i)
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]]
    }
    return resArray
  }
}

// String.prototype.startsWith polyfill for IE
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function (search: string, pos?: number) {
      pos = !pos || pos < 0 ? 0 : +pos
      return this.substring(pos, pos + search.length) === search
    },
  })
}

// String.prototype.endsWith polyfill for IE
if (!String.prototype.endsWith) {
  Object.defineProperty(String.prototype, 'endsWith', {
    value: function (search: string, this_len?: number) {
      const len =
        this_len === undefined || this_len > this.length
          ? this.length
          : this_len
      return this.substring(len - search.length, len) === search
    },
  })
}

// IE适配：Object.assign polyfill
if (typeof Object.assign !== 'function') {
  Object.defineProperty(Object, 'assign', {
    value: function assign(target: any, ...args: any[]) {
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object')
      }
      const to = Object(target)
      for (let i = 0; i < args.length; i++) {
        const nextSource = args[i]
        if (nextSource !== null && nextSource !== undefined) {
          for (const nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey]
            }
          }
        }
      }
      return to
    },
    writable: true,
    configurable: true,
  })
}

// IE适配：NodeList.forEach polyfill
if (
  typeof window !== 'undefined' &&
  window.NodeList &&
  !NodeList.prototype.forEach
) {
  NodeList.prototype.forEach = Array.prototype.forEach as any
}

// 其他可能需要的 polyfills 可以根据需要添加
